import { render, staticRenderFns } from "./Forgot_Password.vue?vue&type=template&id=92944e12&scoped=true&"
import script from "./Forgot_Password.vue?vue&type=script&lang=js&"
export * from "./Forgot_Password.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/login.css?vue&type=style&index=0&id=92944e12&scoped=true&lang=css&"
import style1 from "./Forgot_Password.vue?vue&type=style&index=1&id=92944e12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92944e12",
  null
  
)

export default component.exports